import type { Languages } from '@/i18n/i18n-config'

export type PhoneNumberType = Languages & {
  areaCode: string
}

export const phones: PhoneNumberType[] = [
  {
    name: 'United Kingdom',
    code: 'en',
    icon: '/assets/flags/gb.svg',
    areaCode: '+44',
  },
  {
    name: 'Spain',
    code: 'es',
    icon: '/assets/flags/es.svg',
    areaCode: '+34',
  },
  {
    name: 'Germany',
    code: 'de',
    icon: '/assets/flags/de.svg',
    areaCode: '+49',
  },
  {
    name: 'Poland',
    code: 'pl',
    icon: '/assets/flags/pl.svg',
    areaCode: '+48',
  },
  {
    name: 'Portugal',
    code: 'pt',
    icon: '/assets/flags/pt.svg',
    areaCode: '+351',
  },
  {
    name: 'Russia',
    code: 'ru',
    icon: '/assets/flags/ru.svg',
    areaCode: '+7',
  },
  {
    name: 'China',
    code: 'zh',
    icon: '/assets/flags/cn.svg',
    areaCode: '+86',
  },
  {
    name: 'France',
    code: 'fr',
    icon: '/assets/flags/fr.svg',
    areaCode: '+33',
  },
  {
    name: 'Indonesia',
    code: 'id',
    icon: '/assets/flags/id.svg',
    areaCode: '+62',
  },
  {
    name: 'India',
    code: 'in',
    icon: '/assets/flags/in.svg',
    areaCode: '+91',
  },
  {
    name: 'Italy',
    code: 'it',
    icon: '/assets/flags/it.svg',
    areaCode: '+39',
  },
  {
    name: 'Japan',
    code: 'jp',
    icon: '/assets/flags/jp.svg',
    areaCode: '+81',
  },
]
